import React from "react";
import {useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";
import {tableImageTag} from "../../../helpers/Api";
import {getClientRatings} from "../menus/MenuQueries";
import {Link} from "react-router-dom";
import Loader from "../../shared/Loader";

const ClientRatingsList = ({ client }) => {
  const { data, loading } = useQuery(getClientRatings, { variables: { clientId: client.id } })

  const header = <tr>
    <th>Meniu</th>
    <th>Reteta</th>
    <th>Rating</th>
    <th>Data</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/menus/${item.menu.id}`}>
          {tableImageTag(item.menu)}
          {item.menu.name}
        </Link>
      </td>
      <td>
        <Link to={`/plates/${item.plate.id}`}>
          {tableImageTag(item.plate)}
          {item.plate.name}
        </Link>
      </td>
      <td>{item.rating}</td>
      <td>{item.createdAt}</td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <div className="row justify-content-md-center">
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.clientRatings} header={header} listItem={listItem}
                     searchFields={['name', 'status']} />
        </div>
      </div>
    </div>
  )
};

export default ClientRatingsList;
